export const FLOATING_FIELD_BOX_CLASS = 'group/filter-field relative';

export const FLOATING_INPUT_PLACEHOLDER_CLASS =
  'placeholder:opacity-0 focus:placeholder:opacity-100';
